import { createEntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
  ActionReducer,
  ActionReducerMap,
  combineReducers,
  createFeatureSelector,
  createReducer,
  createSelector,
  MetaReducer,
  on,
} from '@ngrx/store';
import { userFavoritesResModel, virtualCardsResModel } from './models/storage-model';
import { HomeActions } from './home-action-types';
import { state } from '@angular/animations';
import { cardBalanceServiceResModel, cardDetailResModel } from '../models/cardBalanceResponse.model';
import { adapter } from 'src/app/account/ngrx/account-reducers';

export interface FavoritesState extends EntityState<userFavoritesResModel>{
    loadedFavorites: boolean
}

export interface CardsState extends EntityState<virtualCardsResModel>{
    loadedCards: boolean
}

export interface BalancesState extends EntityState<cardDetailResModel>{
}

export interface HomeState{
    loaded: boolean,
    favorites: FavoritesState,
    cards: CardsState,
    balances: BalancesState
}

export const adapterBalances = createEntityAdapter<cardDetailResModel>({
    selectId: (balance: cardDetailResModel) => balance.aliasNo
    //sortComparer 
});

export const adapterFavorites = createEntityAdapter<userFavoritesResModel>({
    selectId: (favorite: userFavoritesResModel) => favorite.favId
    //sortComparer 
});

export const adapterCards = createEntityAdapter<virtualCardsResModel>({
    selectId: (card: virtualCardsResModel) => card.vCardId
    //sortComparer 
});

export const initialBalancesState = adapterBalances.getInitialState({
});

export const initialFavoritesState = adapterFavorites.getInitialState({
    loadedFavorites: false
});

export const initialCardsState = adapterCards.getInitialState({
    loadedCards: false
});

export const balancesReducer = createReducer(
    initialBalancesState,
    on(HomeActions.CardBalanceAdded, (state,action) => adapterBalances.upsertOne(action.balance, state)),    
);

export const cardsReducer = createReducer(
    initialCardsState,
    on(HomeActions.CardsLoaded, (state,action) => adapterCards.addMany(action.cards, {...state, loadedCards:true})),
    on(HomeActions.removeItemsFromUI, (state,action) => adapterCards.removeAll({...state, loadedCards:false})),
);

export const favoritesReducer = createReducer(
    initialFavoritesState,
    on(HomeActions.FavoritesLoaded, (state,action) => adapterFavorites.addMany(action.favorites, {...state, loadedFavorites:true})),    
    on(HomeActions.deleteFavoriteItem, (state,action) => adapterFavorites.removeOne(action.favId, state)),    
    on(HomeActions.FavoriteItemAdded, (state,action) => adapterFavorites.upsertOne(action.favoriteItem, state)),    
    on(HomeActions.removeItemsFromUI, (state,action) => adapterFavorites.removeAll({...state, loadedFavorites:false})),
);

export function favsReducerFn(state: any | undefined, action: Action) {
    return favoritesReducer(state, action);
}

export function cardsReducerFn(state: any | undefined, action: Action) {
    return cardsReducer(state, action);
}

export function balancesReducerFn(state: any | undefined, action: Action) {
    return balancesReducer(state, action);
}

export const homeReducers = {
    balances: balancesReducerFn,
    cards: cardsReducerFn,
    favorites: favsReducerFn,
};

export const {selectAll: selectAllCardBalances} = adapterBalances.getSelectors();
export const {selectAll: selectAllCards} = adapterCards.getSelectors();
export const {selectAll: selectAllFavorites} = adapterFavorites.getSelectors();